import { Container } from "@mui/material";
import PersonalProfileCard from "../logic/PersonalProfileCard";

export default function ProfilePage() {
	return (
		<Container maxWidth="md" sx={{ marginTop: 3, marginBottom: 3}}>
			<PersonalProfileCard />
		</Container>
	);
}
